<script setup lang="ts">
import { computed } from 'vue'
import type { Player } from '../types'

const props = withDefaults(
  defineProps<{
    player: Player | null | undefined
    size?: number
  }>(),
  { size: 56 },
)

const initials = computed(() => {
  const p = props.player
  if (!p) return '?'
  const a = p.firstName?.[0] ?? p.displayName[0] ?? '?'
  const b = p.lastName?.[0] ?? ''
  return (a + b).toUpperCase()
})

// Stable pastel hue from the player id so the same person always gets the same fallback colour.
const bgHue = computed(() => {
  const id = props.player?.id ?? 0
  return (id * 47) % 360
})
</script>

<template>
  <div
    class="shrink-0 rounded-full overflow-hidden flex items-center justify-center font-bold text-white select-none"
    :style="{
      width: `${size}px`,
      height: `${size}px`,
      fontSize: `${Math.max(14, size * 0.4)}px`,
      backgroundColor: player?.pictureUrl ? undefined : `hsl(${bgHue} 55% 32%)`,
    }"
  >
    <img v-if="player?.pictureUrl" :src="player.pictureUrl" :alt="player.displayName" class="w-full h-full object-cover" />
    <span v-else>{{ initials }}</span>
  </div>
</template>
